import { set } from "lodash";
import Kithara from "src/services/kithara";
import { cloneDeep } from "lodash";
const kithara = new Kithara();

// default playlist since some UI items like to read name already
const defaultPlaylist = {
  name: ""
};
export default {
  state: {
    list: {
      loading: false,
      complete: false,
      errors: [],
      playlists: [],
      nextPage: 1,
      pageSize: 40,
      filter: ""
    },
    editing: {
      pending: false,
      errors: [],
      playlist: cloneDeep(defaultPlaylist)
    }
  },
  mutations: {
    PLAYLISTS_LIST_CLEAN: state => {
      state.list.playlists = [];
      state.list.nextPage = 1;
      state.list.complete = false;
    },
    PLAYLISTS_CURRENT_CLEAR: state => {
      state.editing.playlist = cloneDeep(defaultPlaylist);
      state.editing.errors = [];
      state.editing.pending = false;
    },
    PLAYLISTS_LIST: state => {
      state.list.loading = true;
    },
    PLAYLISTS_LIST_FILTER: (state, payload) => {
      state.list.filter = payload;
    },
    PLAYLISTS_LIST_SUCCESS: (state, payload) => {
      state.list.loading = false;
      state.list.playlists = payload.playlists;
      state.list.complete = payload.complete;
      state.list.nextPage++;
    },
    PLAYLISTS_LIST_FAILED: (state, payload) => {
      state.list.loading = false;
      state.list.errors = payload;
    },
    PLAYLISTS_SELECT: state => {
      state.editing.playlist = cloneDeep(defaultPlaylist);
    },
    PLAYLISTS_SET_SELECTED: (state, payload) => {
      state.editing.playlist = payload;
    },
    PLAYLISTS_UPDATE_SELECTED: (state, { path, value }) => {
      set(state.editing.playlist, path, value);
    },
    PLAYLIST_REMOVE_FIELD_SELECTED: (state, { path }) => {
      delete state.editing.playlist[path];
    },
    PLAYLISTS_SELECT_FAILED: () => {
      // do nothing because it should not happen
    },
    PLAYLISTS_UPDATE: state => {
      state.editing.pending = true;
    },
    PLAYLISTS_UPDATE_SUCCESS: state => {
      state.editing.pending = false;
    },
    PLAYLISTS_UPDATE_FAILED: (state, payload) => {
      state.editing.playlist = cloneDeep(defaultPlaylist);
      state.editing.pending = false;
      state.editing.errors = payload;
    },
    PLAYLIST_SET_TEMPLATE_ID: (state, templateId) => {
      state.editing.playlist.template_id = templateId;
    }
  },
  actions: {
    setCurrentPlayList({ commit }, playlist) {
      commit("PLAYLISTS_SET_SELECTED", playlist);
    },
    changePlaylistsFilter({ commit, rootState }, payload) {
      if (!payload) {
        payload = rootState.route.query.filter;
      }
      commit("PLAYLISTS_LIST_FILTER", payload);
    },
    clearCurrentPlaylist({ commit }) {
      commit("PLAYLISTS_CURRENT_CLEAR");
    },
    refreshPlaylists({ commit }) {
      commit("PLAYLISTS_LIST_CLEAN");
    },
    loadMorePlaylists({ state, commit }) {
      if (!state.list.loading && !state.list.complete) {
        commit("PLAYLISTS_LIST");
        const { nextPage, pageSize, filter } = state.list;
        return kithara
          .getPlaylists(nextPage, pageSize, "name|asc", filter)
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("PLAYLISTS_LIST_SUCCESS", {
              playlists: state.list.playlists.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
          })
          .catch(err => commit("PLAYLISTS_LIST_FAILED", [err]));
      }
    },
    updatePlaylistElement({ commit }, { path, value }) {
      value == null
        ? commit("PLAYLIST_REMOVE_FIELD_SELECTED", { path })
        : commit("PLAYLISTS_UPDATE_SELECTED", { path, value });
    },
    fetchPlaylist({ state, commit, rootState }, playlistId) {
      if (playlistId === state.editing.playlist.id) {
        return state.editing.playlist;
      }
      const playlistFromStore = rootState.playlists.list.playlists.find(
        item => item.id === playlistId
      );
      if (playlistFromStore) {
        commit("PLAYLISTS_SET_SELECTED", playlistFromStore);
        return playlistFromStore;
      }
      return kithara.getPlaylist(playlistId).then(resp => {
        const playlistFromDb = resp.data;
        commit("PLAYLISTS_SET_SELECTED", playlistFromDb);
        return playlistFromDb;
      });
    },
    selectPlaylist({ commit, rootState }) {
      commit("PLAYLISTS_SELECT");
      commit("PLAYLIST_ITEMS_LIST_CLEAN");
      return kithara
        .getPlaylist(rootState.route.params.playlistId)
        .then(response => {
          commit("PLAYLISTS_SET_SELECTED", response.data);
        })
        .catch(err => commit("PLAYLISTS_SELECT_FAILED", [err]));
    },
    createPlaylist({ state, commit }) {
      commit("PLAYLISTS_UPDATE");
      commit("PLAYLIST_ITEMS_LIST_CLEAN");
      return kithara
        .createPlaylist(state.editing.playlist)
        .then(response => {
          commit("PLAYLISTS_UPDATE_SUCCESS");
          commit("PLAYLISTS_LIST_CLEAN");
          return response;
        })
        .catch(err => commit("PLAYLISTS_UPDATE_FAILED", [err]));
    },
    savePlaylist({ state, commit, rootState }) {
      commit("PLAYLISTS_UPDATE");
      return kithara
        .updatePlaylist(
          rootState.route.params.playlistId,
          state.editing.playlist
        )
        .then(() => {
          commit("PLAYLISTS_UPDATE_SUCCESS");
          commit("PLAYLISTS_LIST_CLEAN");
        })
        .catch(err => commit("PLAYLISTS_UPDATE_FAILED", [err]));
    },
    deletePlaylist({ commit }, { id }) {
      commit("PLAYLISTS_UPDATE");
      return kithara
        .deletePlaylist(id)
        .then(response => {
          commit("PLAYLISTS_UPDATE_SUCCESS");
          commit("PLAYLISTS_SELECT");
          commit("PLAYLISTS_LIST_CLEAN");
          return response;
        })
        .catch(err => commit("PLAYLISTS_UPDATE_FAILED", [err]));
    }
  },
  getters: {
    playlists: state => state.list.playlists,
    playlistsFilter: state => state.list.filter,
    playlistsLoading: state => state.list.loading,
    playlistsComplete: state => state.list.complete,
    selectedPlaylist: state => state.editing.playlist
  }
};



// WEBPACK FOOTER //
// ./src/store/playlists.js